module.exports = __webpack_public_path__ + "assets/img/jd-banner.696b3bdf.png";